module.exports = __webpack_public_path__ + "static/media/18.b2dbed64.JPG";